export default "__VITE_ASSET__DV6AzlBp__"